import {action} from 'typesafe-actions';

export enum DragAndDropActionTypes {
  SET_DRAG_DATA = 'SET_DRAG_DATA',
  CLEAR_DRAG_DATA = 'CLEAR_DRAG_DATA',
}

export const DragAndDropActions = {
  setDragData: (data: {data: object; name: string}) =>
    action(DragAndDropActionTypes.SET_DRAG_DATA, data),
  clearDragData: () => action(DragAndDropActionTypes.CLEAR_DRAG_DATA),
};
